import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPutPinsale = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await DefaultApi({
                params,
                method: 'put',
                url: urls.PINSALE
            });
            alert('Сохранено');
            
            if (callback) {
                callback();
            }
        } catch (error) {
            getCatchError(error);
        }
    }
}

export {
    setPutPinsale as setPutPinsale
}